import type {PickupStation} from '@yandex-delivery/api/repo/tariffs'
import React from 'react'

import type {LngLat} from '../../../../components/map'
import {Station} from '../../../../components/TariffsMap/components/Station/Station'
import type {ClusterFeature, MapPoint} from '../../../../components/TariffsMap/types'

export const pickupStationsToMapPoints = (stations?: PickupStation[]): MapPoint[] | undefined =>
  stations?.map((station, index) => ({coordinates: toPoint(station), id: String(index)}))

export const marker = ({geometry, properties}: ClusterFeature) => (
  <Station coordinates={geometry.coordinates} onClick={properties?.onPointClick} />
)

const toPoint = ({position}: PickupStation): LngLat => [position.longitude || 0, position.latitude || 0]
